import {html} from 'lit';

export const facet4Template = (isDefault: boolean) => html`

        <div class="image-shapes-4--crop-mobile">
                <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 360 270" xml:space="preserve">
            <g>
                <path class="fill-violet500" d="M61.5,239c21.7,0,39.3-17.6,39.3-39.3s-17.6-39.3-39.3-39.3S22.2,178,22.2,199.7S39.8,239,61.5,239z"/>
            </g>
        </svg>
        </div>
        <div class="image-shapes-4--crop-mobile-overlay">
                <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 360 270" xml:space="preserve">
            <g>
                    <path class="fill-lightblue400-opacity-75" d="M360.1,67.6L274,117.4v99.5l43.1,24.9c13.3,7.7,28.2,11.5,43.1,11.5V67.6z"/>
            </g>
        </svg>
        </div>
        
    <div class="image-shapes-4">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 380 301" xml:space="preserve">
            <g>
                <path class="fill-yellow400" d="M359.6,218.4l0,33c0,11-5.9,21.1-15.4,26.6l-28.5,16.5l-44.9-25.8L359.6,218.4z"/>
                <path class="fill-lightblue400-opacity-75" d="M144.4,253.6l0-71.6l-62-35.8l-31,17.9c-19.2,11.1-31,31.5-31,53.7c0,22.1,11.8,42.6,31,53.7s42.8,11.1,62,0
                    L144.4,253.6z"/>
                <path class="fill-violet500" d="M133.3,63.7c15.6,0,28.2-12.6,28.2-28.2S148.9,7.3,133.3,7.3c-15.6,0-28.2,12.6-28.2,28.2
                    S117.7,63.7,133.3,63.7z"/>
            </g>
        </svg>
    </div>

    <div class="image-shapes-4--xl">
        ${isDefault ? html`
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 492 408" xml:space="preserve">
                <g>
                    <path class="fill-lightblue400-opacity-75" d="M183.9,344.1l0-97.3l-84.2-48.7l-42.1,24.3c-26,15-42.1,42.9-42.1,73c0,30.1,16.1,57.9,42.1,73
                        c26.1,15,58.2,15,84.2,0L183.9,344.1z"/>
                    <path class="fill-violet500" d="M170.9,82.8c21.2,0,38.4-17.2,38.4-38.4S192,6,170.9,6c-21.2,0-38.4,17.2-38.4,38.4S149.7,82.8,170.9,82.8z"/>
                </g>
            </svg>
        ` : html`
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 468 409" xml:space="preserve">
                <g>
                    <path class="fill-violet500" d="M71.4,90.7c21.2,0,38.4-17.2,38.4-38.4c0-21.2-17.2-38.4-38.4-38.4C50.2,13.9,33,31.1,33,52.3
                    C33,73.5,50.2,90.7,71.4,90.7z"/>
                    <path class="fill-lightblue400-opacity-75" d="M367.9,180.3L283.7,229l0,97.3l42.1,24.3c26,15,58.2,15,84.2,0c26.1-15,42.1-42.9,42.1-73
                    c0-30.1-16.1-57.9-42.1-73L367.9,180.3z"/>
                </g>
            </svg>
        `}
    </div>
`;